export default __webpack_public_path__ + "static/media/ruby-red-grapefruit.6238ba16.png";